export class Arrow {
    constructor(tourSceneGuid) {
        this.sceneIndex = 0;
        this.tourSceneGuid = tourSceneGuid;
        this.fov = 0;
    }
}
